// Preselect tokens: the customer fills KYC first, then Pay Now (with Aadhaar eSign) is enabled.

const PAYABLE_STATUSES = ["Payment Pending", "Partial Payment Done", "Preselected"];

// Same rule the preselect Pay Now button has always used.
export function preselectPayNowShown(token) {
  const t = token?.eventTokenId?.tokenId;
  if (!t?.isPreselect || t?.isPriorityPass) return false;
  const status = token?.allotmentPaymentId?.status || "";
  if (!PAYABLE_STATUSES.some((s) => status.includes(s))) return false;
  const paid = Number(token?.paidAmount) || 0;
  return paid === 0 || paid < Number(token?.amount);
}

// Fill KYC shows while KYC is not done: in the old statuses, and whenever preselect Pay Now shows.
export function preselectFillKycShown(token) {
  if (!token?.eventTokenId?.tokenId?.isPreselect || token?.kycFormFilled) return false;
  const oldRule = token?.status === "alloted" || token?.status === "refund rejected";
  return oldRule || preselectPayNowShown(token);
}

export const preselectPayNowLocked = (token) => token?.kycFormFilled !== true;

export const KYC_FIRST_TEXT = "Please fill KYC first to pay";
